import React from 'react';
import { IoLibraryOutline } from "react-icons/io5";
import { LiaToolsSolid } from "react-icons/lia";
import { LiaShapesSolid } from "react-icons/lia";
import { MdOutlineEscalatorWarning } from "react-icons/md";

const sections = [
  {
    icon: <LiaShapesSolid className='Seconde_icon_bg p-2 rounded' size="40px" color="white" />,
    title: "Continuous Innovation",
    description: "We remain at the forefront of educational innovation, constantly evolving our services to offer the latest in E-learning technology and methodologies, ensuring a cutting-edge learning experience."
  },
  {
    icon: <IoLibraryOutline className='Seconde_icon_bg p-2 rounded' size="40px" color="white" />,
    title: "Tailored Curriculum",
    description: "We curate specialized learning paths, tailored to meet diverse educational needs, ensuring a comprehensive and enriching experience for all learners."
  },
  {
    icon: <LiaToolsSolid className='Seconde_icon_bg p-2 rounded' size="40px" color="white" />,
    title: "Interactive Learning Tools",
    description: "Our platform incorporates state-of-the-art interactive tools, fostering engaging and immersive learning experiences that captivate and inspire."
  },
  {
    icon: <MdOutlineEscalatorWarning className='Seconde_icon_bg p-2 rounded' size="40px" color="white" />,
    title: "Expert Guidance",
    description: "Learners benefit from expert guidance and support, ensuring they navigate through courses with clarity and confidence, backed by our experienced educators."
  }
];

function Seconde_Component() {
  return (
    <div>
{/* -------------------------------Mobile View-------------------------------- */}        
      <div className='container-fluid pt-2 d-md-none d-sm-block'>
        <div className='row'>
          <div className='col-md-1'></div>
          <div className='col-md-5 mobile_Seconde_comp_text text-center px-3'>
          <h1 className='py-2'>Utilize Our Best Educational Approach to Unlock Your Career Potential</h1>
          <p>Set out on an unmatched educational adventure with InternsElite. Explore our ever-evolving programs, created to offer customized curricula for a range of needs. Discover engaging educational resources and gain professional advice, guaranteeing that every stage of your journey to achievement is assisted.</p>
          </div>
          <div className='col-md-5 pt-2'>
            <div className='mobile_Seconde_comp px-5 py-3 shadow'>
              <div className='row'>
                {sections.map((section, index) => (
                  <div className='col-md-6 py-2' key={index}>
                    <h6>{section.icon}{' '}{section.title}</h6>
                    <p>{section.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className='col-md-1'></div>
        </div>
      </div>
{/* -------------------------------Desktop View-------------------------------- */}
      <div className='container-fluid d-md-block d-none pt-3'>
        <div className='row'>
          <div className='col-md-1'></div>
          <div className='col-md-5 Seconde_comp_text pt-5 px-3'>
            <h1 className='py-2'>Utilize Our Best Educational Approach to Unlock Your Career Potential</h1>
            <p>Set out on an unmatched educational adventure with InternsElite. Explore our ever-evolving programs, created to offer customized curricula for a range of needs. Discover engaging educational resources and gain professional advice, guaranteeing that every stage of your journey to achievement is assisted.</p>
          </div>
          <div className='col-md-5'>
            <div className='Seconde_comp px-5 py-5 shadow'>
              <div className='row'>
                {sections.map((section, index) => (
                  <div className={`col-md-6 ${index >= 2 ? 'pt-4' : ''}`} key={index}>
                    <h6>{section.icon}{' '}{section.title}</h6>
                    <p>{section.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className='col-md-1'></div>
        </div>
      </div>
    </div>
  );
}

export default Seconde_Component;